import sumate from "../../../constants/assets/homeView/carrousel/sumate2.jpg";
import background1 from "../../../constants/assets/homeView/carrousel/background1.svg";
import m2 from "../../../constants/assets/homeView/carrousel/Imagen1.png";

import Foto1 from '../../../constants/assets/homeView/carrousel/Foto1.png';
import Foto2 from '../../../constants/assets/homeView/carrousel/Foto2.png';
import Foto3 from '../../../constants/assets/homeView/carrousel/Foto3.png';

const carrouselDesktopContent = [
  {
    backgroundImage: sumate,
    title: "Using nanotechnology, we simulate the photosynthesis process.",
  },
  {
    backgroundImage: background1,
    title: "Photio, the only certified and validated decontaminating additive in the world.",
  },
  {
    backgroundImage: m2,
    title: "We create a tool to combat climate change.",
  },
];

const carrouselMobileContentent = [
  {
    backgroundImage: Foto1,
    title: "Using nanotechnology, we simulate the photosynthesis process.",
  },
  {
    backgroundImage: Foto2,
    title: "Photio, the only certified and validated decontaminating additive in the world.",
  },
  {
    backgroundImage: Foto3,
    title: "We create a tool to combat climate change.",
  },
];

export const carrouselContent = {
  carrouselDesktopContent,
  carrouselMobileContentent,
}
